import { FC } from "react";
import SvgIconConstituentValues from "./iconTypes";

export interface SvgIcon extends FC<SvgIconConstituentValues> {}

const Weiblich: SvgIcon = ({ fillColor }) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="120px"
    height="120px"
    viewBox="0 0 534.476 544.001"
    enableBackground="new 0 0 534.476 544.001"
    xmlSpace="preserve"
  >
    <g>
      <defs>
        <rect id="SVGID_1_" width="534.476" height="544.001" />
      </defs>
      <clipPath id="SVGID_2_">
        <use xlinkHref="#SVGID_1_" overflow="visible" />
      </clipPath>
      <path
        clipPath="url(#SVGID_2_)"
        fill={fillColor}
        d="M534.476,544.001C534.476,256.812,414.829,24,267.238,24
       C119.647,24,0,256.812,0,544.001H534.476z"
      />
      <path
        clipPath="url(#SVGID_2_)"
        d="M499.646,428.346c-5.84-47.263-45.887-41.5-93.812-48.646
       c-18.3-2.723-26.242-5.816-41.597-13.598c-13.078,19.078-22.332,49.387-29.423,81.496c-1.315-0.901-3.047-1.391-5.254-1.117
       c-11.871,1.445-7.112,16.112,1.356,15.578c0.315-0.023,0.593-0.102,0.894-0.156c-0.53,2.652-1.047,5.312-1.555,7.969
       c-0.714,0.051-1.418,0.145-2.046,0.312c-5.348,1.418-6.157,4.188-6.098,7.449c0.073,3.867,2.504,6.129,5.461,6.914
       c-0.578,3.277-1.149,6.543-1.696,9.773c-4.093,2.402-4.203,7.523-1.832,10.992c-2.296,13.973-4.347,27.163-6.304,38.688h181.91
       c-3.302-43.211,4.437-79.695,0-115.66L499.646,428.346z"
      />
      <path
        clipPath="url(#SVGID_2_)"
        d="M160.796,230.785c-7.855,11.453-4.312,26.453,0.98,34.392
       c2.239,4.816,5.875,11.694,11.423,21.414c2.883,7.259,12.941,46.12,64.43,35.302c-51.418-57.012-80.32-177.812-36.816-229.872
       c1.644,5.957,5.082,13.352,12.305,19.828c10.227,9.172,23.18,14.739,24.34,14.989c1.16,0.25-8.117-8.645-14.465-14.989
       c0,0-9.301-8.148-11.93-18.035c15.16,14.102,31.203,37.938,48.938,37.762c-8.613-4.734-21.312-16.379-12.398-18.602
       c36.551,32.176,73.233,52.59,93.016,80.605c8.805,53.383-45.547,77.754-30.677,131.13c8.262,0,13.825-2.176,14.622-2.852
       c142.75-109.569,58.461-376.84-95.875-311.789c-14.243,5.336-34.215,14.137-49.074,25.941
       c-12.169,9.668-20.462,17.937-27.469,30.171c-30.352,42.278-34.227,160.67,8.652,164.59L160.796,230.785z"
      />
      <path
        clipPath="url(#SVGID_2_)"
        d="M236.107,446.485c-4.812,0.641-7.176,3.164-7.449,6.773c-0.922,12.027,17.035,11.188,16.254,0
       C244.591,448.688,241.72,445.739,236.107,446.485"
      />
      <path
        clipPath="url(#SVGID_2_)"
        d="M260.487,462.065c9.684-0.121,10.445-17.551-1.355-15.578
       C248.245,448.304,252.796,462.159,260.487,462.065"
      />
      <path
        clipPath="url(#SVGID_2_)"
        d="M283.506,462.065c9.724,0.031,10.734-17.094-0.676-15.578
       C272.029,447.922,274.858,462.034,283.506,462.065"
      />
      <path
        clipPath="url(#SVGID_2_)"
        d="M314.666,452.575c-0.727-5.016-5.266-6.652-8.805-6.098c-5.543,0.875-7.492,2.32-6.772,8.805
       C300.146,464.767,316.223,463.298,314.666,452.575"
      />
      <path
        clipPath="url(#SVGID_2_)"
        d="M235.427,485.085c12.723,1.84,11.78-18.332-0.676-14.897
       C224.895,472.902,230.243,484.332,235.427,485.085"
      />
      <path
        clipPath="url(#SVGID_2_)"
        d="M258.457,485.085c11.599,1.945,13.539-19.137-0.676-14.897
       C247.792,473.164,254.125,484.356,258.457,485.085"
      />
      <path
        clipPath="url(#SVGID_2_)"
        d="M282.836,485.085c12.342,1.047,10.436-18.09-1.352-14.897
       C271.427,472.91,276.728,484.567,282.836,485.085"
      />
      <path
        clipPath="url(#SVGID_2_)"
        d="M304.506,470.186c-5.198,1.551-5.258,2.816-5.418,6.773
       c-0.534,13.19,18.021,8.965,15.574-2.031C313.748,470.807,309.033,468.834,304.506,470.186"
      />
      <path
        clipPath="url(#SVGID_2_)"
        d="M217.467,493.705c-0.496-2.887-1.008-5.781-1.531-8.672c8.851-2.031,5.781-15.711-2.844-15.207
       c-0.535-2.75-1.082-5.488-1.633-8.222c0.727,0.276,1.492,0.452,2.301,0.452c9.46-0.047,10.733-17.68-1.353-15.576
       c-1.593,0.276-2.82,0.819-3.792,1.511c-7.34-34.021-15.824-64.978-23.816-83.492c-2.879-3.383-4.406-5.644-4.406-5.644
       c-12.371,13.396-28.603,17.396-51.754,20.847c-47.926,7.145-87.969,1.383-93.813,48.646c-4.441,35.962,3.301,72.444,0,115.649
       h190.051c-1.441-12.125-3.281-25.101-5.426-38.379C222.076,501.806,221.737,495.7,217.467,493.705L217.467,493.705z"
      />
      <path
        clipPath="url(#SVGID_2_)"
        d="M237.467,508.785c9.434-0.5,9.276-16.965-1.353-15.578
       C224.416,494.738,228.298,509.273,237.467,508.785"
      />
      <path
        clipPath="url(#SVGID_2_)"
        d="M260.487,508.785c9.492-0.117,10.703-17.676-1.355-15.578
       C248.354,495.082,252.694,508.88,260.487,508.785"
      />
      <path
        clipPath="url(#SVGID_2_)"
        d="M284.188,508.785c9.456-0.504,9.245-16.883-1.353-15.578
       C271.039,494.664,275.035,509.273,284.188,508.785"
      />
      <path
        clipPath="url(#SVGID_2_)"
        d="M307.217,508.785c9.685-0.117,10.448-17.551-1.355-15.578
       C294.979,495.027,299.526,508.88,307.217,508.785"
      />
      <path
        clipPath="url(#SVGID_2_)"
        d="M234.756,516.905c-9.539,2.633-5.031,14.074,0.676,14.898
       C246.713,533.44,248.944,512.994,234.756,516.905"
      />
      <path
        clipPath="url(#SVGID_2_)"
        d="M257.777,516.905c-11.189,3.336-3,16.523,4.742,14.898
       C272.246,529.762,267.976,513.869,257.777,516.905"
      />
      <path
        clipPath="url(#SVGID_2_)"
        d="M280.807,516.905c-9.762,3.402-3.438,14.439,2.031,14.898
       C293.975,532.749,294.818,512.022,280.807,516.905"
      />
      <path
        clipPath="url(#SVGID_2_)"
        d="M304.506,516.905c-11.188,3.336-3,16.523,4.742,14.898
       C318.972,529.762,314.705,513.869,304.506,516.905"
      />
      <path clipPath="url(#SVGID_2_)" d="M230.017,543.995h13.547C242.345,538.007,231.232,538.007,230.017,543.995" />
      <path
        clipPath="url(#SVGID_2_)"
        d="M253.717,543.995h13.547v-0.68C264.99,538.473,255.139,537.921,253.717,543.995"
      />
      <path clipPath="url(#SVGID_2_)" d="M276.736,543.995h13.543C289.064,538.007,277.952,538.007,276.736,543.995" />
      <path
        clipPath="url(#SVGID_2_)"
        d="M300.438,543.995h13.547v-0.68C311.71,538.473,301.859,537.921,300.438,543.995"
      />
    </g>
  </svg>
);

export default Weiblich;
